export const HOMESTAY_RATE_LIST_ACTION = "HOMESTAY_RATE_ACTION";
export const HOMESTAY_RATE_LIST_SUCCESS = "HOMESTAY_RATE_LIST_SUCCESS";
export const HOMESTAY_RATE_LIST_FAIL = "HOMESTAY_RATE_LIST_FAIL";
export const HOMESTAY_RATE_DETAIL_ACTION = "HOMESTAY_RATE_DETAIL_ACTION";
export const HOMESTAY_RATE_DETAIL_SUCCESS = "HOMESTAY_RATE_DETAIL_SUCCESS";
export const HOMESTAY_RATE_DETAIL_FAIL = "HOMESTAY_RATE_DETAIL_FAIL";
export const HOMESTAY_RATE_FAIL = "HOMESTAY_RATE_FAIL";
export const HOMESTAY_RATE_SAVE_SUCCESS = "HOMESTAY_RATE_SAVE_SUCCESS";
export const HOMESTAY_RATE_SAVE_ACTION = "HOMESTAY_RATE_SAVE_ACTION";
export const HOMESTAY_RATE_SAVE_FAIL = "HOMESTAY_RATE_SAVE_FAIL";

export const HOMESTAY_RATE_CREATE_TRANSLATE_ACTION = "HOMESTAY_RATE_CREATE_TRANSLATE_ACTION";
export const HOMESTAY_RATE_CREATE_TRANSLATE_SUCCESS = "HOMESTAY_RATE_CREATE_TRANSLATE_SUCCESS";

export const HOMESTAY_RATE_UPDATE_TRANSLATE_ACTION = "HOMESTAY_RATE_UPDATE_TRANSLATE_ACTION";
export const HOMESTAY_RATE_UPDATE_TRANSLATE_SUCCESS = "HOMESTAY_RATE_UPDATE_TRANSLATE_SUCCESS";

export const HOMESTAY_RATE_DELETE_TRANSLATE_ACTION = "HOMESTAY_RATE_DELETE_TRANSLATE_ACTION";
export const HOMESTAY_RATE_DELETE_TRANSLATE_SUCCESS = "HOMESTAY_RATE_DELETE_TRANSLATE_SUCCESS";

export const HOMESTAY_RATE_SORT_ACTION = "HOMESTAY_RATE_SORT_ACTION";
export const HOMESTAY_RATE_SORT_SUCCESS = "HOMESTAY_RATE_SORT_SUCCESS";

export const HOMESTAY_RATE_SYNC_ALL_HOTELS_ACTION = "HOMESTAY_RATE_SYNC_ALL_HOTELS_ACTION";
export const HOMESTAY_RATE_SYNC_ALL_HOTELS_SUCCESS = "HOMESTAY_RATE_SYNC_ALL_HOTELS_SUCCESS"

export const HOMESTAY_RATE_SYNC_HOMESTAY_RATES_ACTION = "HOMESTAY_RATE_SYNC_HOMESTAY_RATES_ACTION";
export const HOMESTAY_RATE_SYNC_HOMESTAY_RATES_SUCCESS = "HOMESTAY_RATE_SYNC_HOMESTAY_RATES_SUCCESS"

export const HOMESTAY_RATE_LIST_BY_HOMESTAYS_ACTION = "HOMESTAY_RATE_LIST_BY_HOMESTAYS_ACTION";
export const HOMESTAY_RATE_LIST_BY_HOMESTAYS_SUCCESS = "HOMESTAY_RATE_LIST_BY_HOMESTAYS_SUCCESS";
export const HOMESTAY_RATE_LIST_BY_HOMESTAYS_FAIL = "HOMESTAY_RATE_LIST_BY_HOMESTAYS_FAIL";

export const HOMESTAY_RATE_CANCEL_POLICY_SYNC_ACTION = "HOMESTAY_RATE_CANCEL_POLICY_SYNC_ACTION";
export const HOMESTAY_RATE_CANCEL_POLICY_SYNC_SUCCESS = "HOMESTAY_RATE_CANCEL_POLICY_SYNC_SUCCESS"
export const HOMESTAY_RATE_CANCEL_POLICY_UPDATE_ACTION = "HOMESTAY_RATE_CANCEL_POLICY_UPDATE_ACTION";
export const HOMESTAY_RATE_CANCEL_POLICY_UPDATE_SUCCESS = "HOMESTAY_RATE_CANCEL_POLICY_UPDATE_SUCCESS";
export const HOMESTAY_RATE_CANCEL_POLICY_FAIL = "HOMESTAY_RATE_CANCEL_POLICY_FAIL";

export const HOMESTAY_RATE_USAGE_STATUS_ACTION = "HOMESTAY_RATE_USAGE_STATUS_ACTION";
export const HOMESTAY_RATE_USAGE_STATUS_SUCCESS = "HOMESTAY_RATE_USAGE_STATUS_SUCCESS";

export const HOMESTAY_RATE_UPDATE_ACTIVE_ACTION = "HOMESTAY_RATE_UPDATE_ACTIVE_ACTION";
export const HOMESTAY_RATE_UPDATE_ACTIVE_SUCCESS = "HOMESTAY_RATE_UPDATE_ACTIVE_SUCCESS";

export const SYNC_HOMESTAY_RATE_LANGUAGE_ACTION = "SYNC_HOMESTAY_RATE_LANGUAGE_ACTION";
export const SYNC_HOMESTAY_RATE_LANGUAGE_SUCCESS = "SYNC_HOMESTAY_RATE_LANGUAGE_SUCCESS";
export const SYNC_HOMESTAY_RATE_LANGUAGE_FAIL = "SYNC_HOMESTAY_RATE_LANGUAGE_FAIL";

export const HOMESTAY_RATE_UPDATE_EXTEND_ACTION = "HOMESTAY_RATE_UPDATE_EXTEND_ACTION";
export const HOMESTAY_RATE_UPDATE_EXTEND_SUCCESS = "HOMESTAY_RATE_UPDATE_EXTEND_SUCCESS";